import React from 'react';
import { useTranslation } from 'react-i18next';

import UpdateMyInfoForm from './UpdateMyInfoForm';
// Types.
import { UpdateInfo } from '../../types/customer';

const UpdateMyInfo: React.FunctionComponent<UpdateInfo> = (props: UpdateInfo) => {
  const { customer, setUpdateUsers } = props;
  const { t } = useTranslation();

  return (
    <div className="form">
      <div>
        <p>{t('myInfo:customerInfo.contact', { company: t(`common:company.${customer.endpoint}`) })}</p>
        <UpdateMyInfoForm customer={customer} endpoint={customer.endpoint} setUpdateUsers={setUpdateUsers} />
      </div>
    </div>
  );
};

export default UpdateMyInfo;
